import { render, staticRenderFns } from "./CameraCapture.vue?vue&type=template&id=142fe8d2"
import script from "./CameraCapture.vue?vue&type=script&lang=js"
export * from "./CameraCapture.vue?vue&type=script&lang=js"
import style0 from "./CameraCapture.vue?vue&type=style&index=0&id=142fe8d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports